<template>
  <div>
    <v-autocomplete 
    clearable 
    :label="label"
    :color="color"
    :items="items"
    :item-text="text"
    :item-value="value"
    :multiple="multiple"
    v-model="selection"
    >
    </v-autocomplete>
  </div>
</template>

<script>
export default {
    watch: {
        selection(value) {
            this.$emit('item-selected', value);
        }
    },
    props: {
        label: {
            default: 'Search'
        },
        items: {
            default: []
        },
        color: {
            default: 'white'
        },
        text: {
            default: 'text'
        },
        value: {
            default: 'value'
        },
        multiple: {
            default: false
        },
    },
    data: () => ({
        selection:null
    })
}
</script>

<style>

</style>